/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect, useState } from "react";

import { Button, DatePicker, Form, Input, notification, Spin } from "antd";
import LayoutBaseAdmin from "components/LayoutBaseAdmin";
import LayoutBaseBusiness from "components/SuperAdminAndBusiness/LayoutBaseBusiness";
import TitleWithBreadCrumb from "components/TitleWithBreadCrumb";
import { AuthContext } from "contexts/AuthContext";
import dayjs from "dayjs";
import queryString from "query-string";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  getReportIssueByUuid,
  updateReportIssue,
} from "services/reportIssuesService";
import { getTasksAndUsersList } from "services/taskService";
interface UserTask {
  uuid: string;
  name: string;
}

const OpenInvestigationPage: React.FC = () => {
  const { t, i18n }: { t: (key: string, options?: any) => string; i18n: any } =
    useTranslation();

  const [form] = Form.useForm();
  const navigate = useNavigate();

  const { issue } = queryString.parse(window.location.search);

  const { user } = useContext(AuthContext);

  const [loading, setLoading] = useState<boolean>(false);

  const [reportId, setReportId] = useState<string>("");
  const [reportIssueUuid, setReportIssueUuid] = useState<string>("");

  const [reportIssueData, setReportIssueData] = useState<any>({});

  const [usersOnTask, setUsersOnTask] = useState<UserTask[]>([]);

  const getReportIssueData = async () => {
    try {
      setLoading(true);

      if (typeof issue === "string") {
        const response = await getReportIssueByUuid(issue);

        if (response) {
          setReportIssueData(response);
          setReportIssueUuid(response.uuid);
          setReportId(response.reportUuid);

          const formattedReportedDate = response.reportedDate
            ? dayjs(response.reportedDate).isValid()
              ? dayjs(response.reportedDate)
              : null
            : null;

          const formattedallegedIncidentDate = response.allegedIncidentDate
            ? dayjs(response.allegedIncidentDate).isValid()
              ? dayjs(response.allegedIncidentDate)
              : null
            : null;

          const formatteddueDate = response.dueDate
            ? dayjs(response.dueDate).isValid()
              ? dayjs(response.dueDate)
              : null
            : null;

          response.summary =
            response.reportIssuesLanguage &&
            response.reportIssuesLanguage.language === i18n.language
              ? response.reportIssuesLanguage.summary
                ? response.reportIssuesLanguage.summary
                : response.summary
              : response.summary;

          form.setFieldsValue({
            ...response,
            witnesses:
              response.witnesses === "[object Object]"
                ? ""
                : response.witnesses,
            reportedDate: formattedReportedDate,
            dueDate: formatteddueDate,
            allegedIncidentDate: formattedallegedIncidentDate,
          });
        }
      }
    } catch (error: any) {
      notification.error({
        placement: "bottomRight",
        message:
          error?.response?.data?.message ||
          t("anErrorOccurredDuringTheOperation"),
      });
    } finally {
      setLoading(false);
    }
  };

  const getTaskAndUsersData = async () => {
    try {
      setLoading(true);

      if (typeof issue === "string") {
        const response = await getTasksAndUsersList(issue);

        if (response && response.data && Array.isArray(response.data)) {
          const extractedUsers = response.data
            .map((task) => task.users || [])
            .reduce((acc, users) => acc.concat(users), []);

          if (extractedUsers.length > 0) {
            setUsersOnTask(extractedUsers);

            const allUserNames = extractedUsers.map((user) => user.name);

            form.setFieldsValue({
              caseAssignees: allUserNames,
            });
          }
        } else {
          notification.error({
            placement: "bottomRight",
            message: t("wrongAnswer"),
          });
        }
      }
    } catch (error: any) {
      notification.error({
        placement: "bottomRight",
        message:
          error?.response?.data?.message ||
          t("anErrorOccurredDuringTheOperation"),
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getReportIssueData();
    getTaskAndUsersData();
  }, [i18n.language]);

  const handleUpdate = async (values) => {
    try {
      const witnesses = values?.witnesses;
      const location = values?.location;
      const title = values.title;
      const summary = values.summary;
      const reportedDate = values?.reportedDate
        ? dayjs(values.reportedDate).toDate() // Convertendo para Date
        : undefined;
      const dueDate = values?.dueDate
        ? dayjs(values.dueDate).toDate()
        : undefined; // Convertendo para Date
      const allegedIncidentDate = values?.allegedIncidentDate
        ? dayjs(values.allegedIncidentDate).toDate() // Convertendo para Date
        : undefined;

      const reportIssueData = {
        witnesses,
        location,
        title,
        summary,
        reportedDate,
        dueDate,
        allegedIncidentDate,
      };
      const response = await updateReportIssue(
        reportIssueUuid,
        reportIssueData
      );

      if (response) {
        notification.success({
          placement: "bottomRight",
          message: t("complaintIssueUpdatedWithSuccess"),
        });
        // window.location.reload();
      }
    } catch (error: any) {
      notification.error({
        placement: "bottomRight",
        message:
          error?.response?.data?.message ||
          t("anErrorOccurredWhileSubmittingTheComment"),
      });
    }
  };
  // const handleSubmit = async () => {
  //   try {
  //     const values = await form.validateFields();
  //     values.reportUuid = reportId;
  //     values.reportedDate = dayjs(values.reportedDate).format();
  //     values.allegedIncidentDate = dayjs(values.allegedIncidentDate).format();
  //     values.dueDate = dayjs(values.dueDate).format();

  //     const response = await createReportIssue(values);

  //     if (response) {
  //       notification.success({
  //         placement: "bottomRight",
  //         message: "Investigation opened successfully.",
  //         duration: 3,
  //       });
  //       navigate(
  //         `/${
  //           user && user.type === "supervisor" ? "business" : "analyst"
  //         }/reports`
  //       );
  //     } else {
  //       notification.error({
  //         message: "There is a problem, check the information.",
  //         placement: "bottomRight",
  //         duration: 3,
  //       });
  //     }
  //   } catch (error) {
  //   }
  // };

  const LayoutComponent =
    user &&
    (user.type === "supervisor" ||
      user.type === "admin" ||
      user.type === "superAdmin")
      ? LayoutBaseBusiness
      : LayoutBaseAdmin;

  return (
    <>
      <LayoutComponent>
        <Spin spinning={loading} fullscreen />

        <div className="flex flex-col h-full w-full">
          <TitleWithBreadCrumb
            actualPage={t("openInvestigation")}
            title={t("openInvestigation")}
            backPage={`${
              reportIssueData.caseIssue
                ? reportIssueData.caseIssue
                : reportIssueData.caseNumber
            }`}
            navigateTo={`/${
              user &&
              (user.type === "supervisor" ||
                user.type === "admin" ||
                user.type === "superAdmin")
                ? "business"
                : "analyst"
            }/intake/issue?issue=${issue}`}
          />
          <Form
            form={form}
            className="flex flex-col gap-5 w-full mt-10"
            layout="vertical"
            onFinish={handleUpdate}
          >
            <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
              <Form.Item
                className="md:w-full"
                name="caseNumber"
                label={
                  <div className="text-base font-semibold">
                    {t("caseNumber")}
                  </div>
                }
              >
                <Input
                  defaultValue={reportIssueData.caseNumber}
                  disabled
                  id="caseNumber"
                  className="w-full rounded-md"
                  size="large"
                />
              </Form.Item>
              <Form.Item
                className="md:w-full"
                name="reportedDate"
                label={
                  <div className="text-base font-semibold">
                    {t("reportedDate")}
                  </div>
                }
              >
                <DatePicker
                  placeholder={t("selectADate")}
                  id="reportedDate"
                  size="large"
                  className="w-full h-[40px]"
                  allowClear
                  format={"MM/DD/YYYY"}
                />
              </Form.Item>
              {/* Adicione os outros 2 Form.Items aqui */}
              <Form.Item
                className="md:w-full"
                name="allegedIncidentDate"
                label={
                  <div className="text-base font-semibold">
                    {t("allegedIncidentDate")}
                  </div>
                }
              >
                <DatePicker
                  placeholder={t("selectADate")}
                  id="allegedIncidentDate"
                  size="large"
                  className="w-full h-[40px]"
                  allowClear
                  format={"MM/DD/YYYY"}
                />
              </Form.Item>
              <Form.Item
                className="md:w-full"
                name="dueDate"
                label={
                  <div className="text-base font-semibold">{t("dueDate")}</div>
                }
              >
                <DatePicker
                  placeholder={t("selectADate")}
                  id="dueDate"
                  size="large"
                  className="w-full h-[40px]"
                  allowClear
                  format={"MM/DD/YYYY"}
                />
              </Form.Item>
              <Form.Item
                className="md:w-full"
                name="location"
                label={
                  <div className="text-base font-semibold">{t("location")}</div>
                }
              >
                <Input
                  id="location"
                  size="large"
                  placeholder="Type Here"
                  className="w-full rounded-md"
                  allowClear
                />
              </Form.Item>
              <Form.Item
                className="md:w-full"
                name="caseIssue"
                label={
                  <div className="text-base font-semibold">
                    {t("issueCategory")}
                  </div>
                }
              >
                <Input
                  disabled
                  id="caseIssue"
                  size="large"
                  placeholder={t("typeHere")}
                  className="w-full rounded-md"
                  allowClear
                />
              </Form.Item>
              <Form.Item
                className="md:w-full"
                name={["reportIssuePriorities", "priority"]}
                label={
                  <div className="text-base font-semibold">
                    {t("assignedRiskTier")}
                  </div>
                }
              >
                <Input
                  disabled
                  id="reportIssuePriorities.priority"
                  size="large"
                  placeholder={t("typeHere")}
                  className="w-full rounded-md"
                  allowClear
                />
              </Form.Item>
              <Form.Item
                className="md:w-full"
                name="witnesses"
                label={
                  <div className="text-base font-semibold">
                    {t("witnesses")}
                  </div>
                }
              >
                <Input
                  disabled
                  id="witnesses"
                  size="large"
                  placeholder={t("typeHere")}
                  className="w-full rounded-md"
                  allowClear
                />
              </Form.Item>
            </div>

            <div className="w-full">
              <Form.Item
                name="summary"
                label={
                  <div className="text-base font-semibold">{t("summary")}</div>
                }
              >
                <Input.TextArea
                  rows={5}
                  id="summary"
                  size="large"
                  placeholder={t("typeHere")}
                  className="w-full rounded-md"
                  allowClear
                />
              </Form.Item>
            </div>

            <div className="w-full flex items-center justify-end gap-3">
              <Button
                size="large"
                className="border text-blue_gray-400 border-solid cursor-pointer min-w-[102px] text-center"
                onClick={() =>
                  navigate(
                    `/${
                      user &&
                      (user.type === "supervisor" ||
                        user.type === "admin" ||
                        user.type === "superAdmin")
                        ? "business"
                        : "analyst"
                    }/intake/issue?issue=${issue}`
                  )
                }
              >
                {t("cancel")}
              </Button>
              <Button
                className="min-w-[102px] text-center"
                htmlType="submit"
                size="large"
                style={{
                  background: "var(--primary_color)",
                  color: "var(--white_A700)",
                }}
              >
                {t("openInvestigation")}
              </Button>
            </div>
          </Form>
        </div>
      </LayoutComponent>
    </>
  );
};

export default OpenInvestigationPage;
